'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require ('materialize-css');
require ('slick-carousel');
const waypoint = require('./jquery.waypoints.min');
const contact = require('./contact');
import swal from 'sweetalert';
//importarScript("js/jquery.waypoints.min.js");
var contLogin,campo,emailRegex;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    $('.sectionHeader .woman').css('visibility','hidden');
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    //window.load = cargar();
    cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$(window).scroll(function() {
    if($(window).width() < 600) {
        if ($(document).scrollTop() > 80) {
            $('#wpFloat').css('display','block');
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=75){
                $('#wpFloat').css('display','none');
            }
        }
    }
});

$(document).ready(function() {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'linear',
        fade: true,
    });
    $('#sliderBanner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".sectionHomeBanner .element").css('visibility','hidden');
        $(".sectionHomeBanner .element").removeClass('animated zoomIn');
        $(".sectionHomeBanner img").css('transition','transform 0s');
        $(".sectionHomeBanner img").css('transform','scale(1.1)');
    });
    $('#sliderBanner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function () {
            $(".sectionHomeBanner .element").css('visibility','inherit');
            $(".sectionHomeBanner .element").addClass('animated zoomIn');
            $(".sectionHomeBanner img").css('transition','transform 4s');
            $(".sectionHomeBanner img").css('transform','scale(1)');
        },100);
    });

    /*projects*/
    $('#sliderProjects-todos').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderProjects-todos'),
        nextArrow: $('.next-slider-sliderProjects-todos'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    /*
    $('#sliderProjects-stand').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderProjects-stand'),
        nextArrow: $('.next-slider-sliderProjects-stand'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#sliderProjects-escen').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderProjects-escen'),
        nextArrow: $('.next-slider-sliderProjects-escen'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#sliderProjects-islas').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderProjects-islas'),
        nextArrow: $('.next-slider-sliderProjects-islas'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#sliderProjects-retail').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderProjects-retail'),
        nextArrow: $('.next-slider-sliderProjects-retail'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
    */

    /*endprojects*/

    $('#sliderBlog').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderBlog'),
        nextArrow: $('.next-slider-sliderBlog'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    var access_token = location.hash.split('=')[1];
    var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
    $.getJSON(URL_API_INSTAGRAM,function(data) {
        var i = 1;
        $('.instragramImages').html("");
        $.each(data.data, function (item, value) {
            if (i <= 8) {
                $('.instragramImages').append('' +
                    '<div class="">' +
                        '<a target="_blank" href="' + data.data[item].link + '">' +
                            '<div class="element">'+
                            '   <div class="containerInstagram">' +
                            '       <div class="img">'+
                            '           <img src="' + value.images.low_resolution.url + '" alt="">' +
                            '       </div>'+
                            '   </div>' +
                            '</div>'+
                        '</a>' +
                    '</div>');
            }
            i++;
        });
        if(i >= 8){
            alert('hello');
            $('#sliderInsta').slick({
                dots: true,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                adaptiveHeight: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 3000,
                prevArrow: $('.prev-slider-sliderIns'),
                nextArrow: $('.next-slider-sliderIns'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    });
});

/*
$('.seeProject').click(function () {
    $.ajax({
        async:true,
        type: "POST",
        dataType: "json",
        url: https + "seeProjectGalery",
        data:{id:this.id,action:'seeProject'},
        success:function(datos){
            if($.trim(datos) == 0){
                swal({
                    text: "No hay galeria disponible",
                    icon: imageURL,
                    button: "OK!",
                });
            }else if($.isEmptyObject(datos)){
                swal({
                    text: "No hay galeria disponible",
                    icon: imageURL,
                    button: "OK!",
                });
            }else{
                $('#sliderGaleriaProjectFor').html("");
                $('#sliderGaleriaProjectForNav').html("");
                $('#sliderGaleriaProjectFor').removeClass('slick-initialized');
                $('#sliderGaleriaProjectFor').removeClass('slick-slider');
                $('#sliderGaleriaProjectForNav').removeClass('slick-initialized');
                $('#sliderGaleriaProjectForNav').removeClass('slick-slider');
                $.each(datos, function(index, c) {
                    $('#sliderGaleriaProjectFor').append("" +
                        "<div>" +
                        "   <div class=\"img\">" +
                        "       <div>" +
                        "           <img src='"+https+c.img+"' alt=''>" +
                        "       </div>" +
                        "   </div>"+
                        "</div>");
                    $('#sliderGaleriaProjectForNav').append("" +
                        "<div>" +
                        "   <img src='"+https+c.img+"' alt=''>" +
                        "</div>");
                });

                $('#sliderGaleriaProjectFor').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: true,
                    prevArrow: $('.prev-slider-sliderGaleriaProjectFor'),
                    nextArrow: $('.next-slider-sliderGaleriaProjectFor'),
                    asNavFor: '#sliderGaleriaProjectForNav'
                });
                $('#sliderGaleriaProjectForNav').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    asNavFor: '#sliderGaleriaProjectFor',
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    focusOnSelect: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
                $('#modalProjects').modal('open');
            }
        }
    });
});
*/

$(window).scroll(function() {
    if ($(window).width() > 901) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#000000', '!important');
            $('.header').css('height', '80px', '!important');
            $('.header').css('line-height', '100px', '!important');
            //$('.header .brand-logo .logo_white').css('display', 'none', '!important');
            //$('.header .brand-logo .logo_black').css('display', 'inherit', '!important');
            $('.header .brand-logo img').css('width', '50px', '!important');
            /*
            $('.header .face_black').css('visibility', 'inherit', '!important');
            $('.header .face_black').css('position', 'relative', '!important');
            $('.header .face_white').css('visibility', 'hidden', '!important');
            $('.header .face_white').css('position', 'absolute', '!important');
            $('.header .ins_black').css('visibility', 'inherit', '!important');
            $('.header .ins_black').css('position', 'relative', '!important');
            $('.header .ins_white').css('visibility', 'hidden', '!important');
            $('.header .ins_white').css('position', 'absolute', '!important');
            $('.header .you_black').css('visibility', 'inherit', '!important');
            $('.header .you_black').css('position', 'relative', '!important');
            $('.header .you_white').css('visibility', 'hidden', '!important');
            $('.header .you_white').css('position', 'absolute', '!important');
            $('.header .menu_black').css('visibility', 'inherit', '!important');
            $('.header .menu_black').css('position', 'relative', '!important');
            $('.header .menu_white').css('visibility', 'hidden', '!important');
            $('.header .menu_white').css('position', 'absolute', '!important');
            */
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header').css('height', '120px', '!important');
                $('.header').css('line-height', '120px', '!important');
                //$('.header .brand-logo .logo_white').css('display', 'inherit', '!important');
                //$('.header .brand-logo .logo_black').css('display', 'none', '!important');
                $('.header .brand-logo img').css('width', '80px', '!important');
                /*
                $('.header .face_white').css('visibility', 'inherit', '!important');
                $('.header .face_white').css('position', 'relative', '!important');
                $('.header .face_black').css('visibility', 'hidden', '!important');
                $('.header .face_black').css('position', 'absolute', '!important');
                $('.header .ins_white').css('visibility', 'inherit', '!important');
                $('.header .ins_white').css('position', 'relative', '!important');
                $('.header .ins_black').css('visibility', 'hidden', '!important');
                $('.header .ins_black').css('position', 'absolute', '!important');
                $('.header .you_white').css('visibility', 'inherit', '!important');
                $('.header .you_white').css('position', 'relative', '!important');
                $('.header .you_black').css('visibility', 'hidden', '!important');
                $('.header .you_black').css('position', 'absolute', '!important');
                $('.header .menu_white').css('visibility', 'inherit', '!important');
                $('.header .menu_white').css('position', 'relative', '!important');
                $('.header .menu_black').css('visibility', 'hidden', '!important');
                $('.header .menu_black').css('position', 'absolute', '!important');
                */
            }
        }
    }
});



/*
$('.tab_todos').click(function () {
    $('#todos').css('visibility','initial');
    $('#stand').css('visibility','hidden');
    $('#escen').css('visibility','hidden');
    $('#islas').css('visibility','hidden');
    $('#retail').css('visibility','hidden');

    $('#todos').css('z-index','1');
    $('#stand').css('z-index','-1');
    $('#escen').css('z-index','-1');
    $('#islas').css('z-index','-1');
    $('#retail').css('z-index','-1');
});

$('.tab_stand').click(function () {
    $('#todos').css('visibility','hidden');
    $('#stand').css('visibility','initial');
    $('#escen').css('visibility','hidden');
    $('#islas').css('visibility','hidden');
    $('#retail').css('visibility','hidden');

    $('#todos').css('z-index','-1');
    $('#stand').css('z-index','1');
    $('#escen').css('z-index','-1');
    $('#islas').css('z-index','-1');
    $('#retail').css('z-index','-1');
});

$('.tab_escen').click(function () {
    $('#todos').css('visibility','hidden');
    $('#stand').css('visibility','hidden');
    $('#escen').css('visibility','initial');
    $('#islas').css('visibility','hidden');
    $('#retail').css('visibility','hidden');

    $('#todos').css('z-index','-1');
    $('#stand').css('z-index','-1');
    $('#escen').css('z-index','1');
    $('#islas').css('z-index','-1');
    $('#retail').css('z-index','-1');
});

$('.tab_islas').click(function () {
    $('#todos').css('visibility','hidden');
    $('#stand').css('visibility','hidden');
    $('#escen').css('visibility','hidden');
    $('#islas').css('visibility','initial');
    $('#retail').css('visibility','hidden');

    $('#todos').css('z-index','-1');
    $('#stand').css('z-index','-1');
    $('#escen').css('z-index','-1');
    $('#islas').css('z-index','1');
    $('#retail').css('z-index','-1');
});

$('.tab_retail').click(function () {
    $('#todos').css('visibility','hidden');
    $('#stand').css('visibility','hidden');
    $('#escen').css('visibility','hidden');
    $('#islas').css('visibility','hidden');
    $('#retail').css('visibility','initial');

    $('#todos').css('z-index','-1');
    $('#stand').css('z-index','-1');
    $('#escen').css('z-index','-1');
    $('#islas').css('z-index','-1');
    $('#retail').css('z-index','1');
});
*/
$(window).scroll(function() {
    if($(window).width() > 901) {
        $('.sectionHomeServices .col-1 .img-1').waypoint(function(direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionHomeServices .h1-1').css('visibility', 'inherit');
                    $('.sectionHomeServices .h1-1').addClass('animated slideInRight');
                },200);
            }
        },{offset: '50%'});
        $('.sectionHomeServices .col-2 .img-2').waypoint(function(direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionHomeServices .h1-2').css('visibility', 'inherit');
                    $('.sectionHomeServices .h1-2').addClass('animated slideInLeft');
                },200);
            }
        },{offset: '50%'});
        $('.sectionHomeServices .col-3 .img-3').waypoint(function(direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionHomeServices .h1-3').css('visibility', 'inherit');
                    $('.sectionHomeServices .h1-3').addClass('animated slideInRight');
                },200);
            }
        },{offset: '50%'});
        $('.sectionHomeServices .col-4 .img-4').waypoint(function(direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionHomeServices .h1-4').css('visibility', 'inherit');
                    $('.sectionHomeServices .h1-4').addClass('animated slideInLeft');
                },200);
            }
        },{offset: '50%'});
    }
});

/*
$( '.img-1' ).mousemove( function( e ) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    console.log(mouseX + ' + ' +mouseY);
} );
*/


function sigueme(mouseX,mouseY,)
{
//Capto las coordenads del puntero.
    var x = window.event.x;
    var y = window.event.y;
//Y se las coloco al div.
    document.getElementById("siguelo").style.left = mouseX-50 + "px";
    document.getElementById("siguelo").style.top = mouseY-50 + "px";
    document.getElementById("color").style.left = -(mouseX-50) + "px";
    document.getElementById("color").style.top = -(mouseY-50) + "px";
}

$('.sectionHomeClients .element').on('mousemove',function (e) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    sigueme(mouseX,mouseY);
});

$('.sectionHomeServices .element_1').on('mousemove',function (e) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    follow(mouseX,mouseY,'siguelo_1','color_1');
});


$('.sectionHomeServices .element_2').on('mousemove',function (e) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    follow(mouseX,mouseY,'siguelo_2','color_2');
});

$('.sectionHomeServices .element_3').on('mousemove',function (e) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    follow(mouseX,mouseY,'siguelo_3','color_3');
});

$('.sectionHomeServices .element_4').on('mousemove',function (e) {
    var mouseX = e.pageX - $( this ).offset().left;
    var mouseY = e.pageY - $( this ).offset().top;
    follow(mouseX,mouseY,'siguelo_4','color_4');
});

function follow(mouseX,mouseY,siguelo,color)
{
    document.getElementById(siguelo).style.left = mouseX-230 + "px";
    document.getElementById(siguelo).style.top = mouseY-230 + "px";
    document.getElementById(color).style.left = -(mouseX-230) + "px";
    document.getElementById(color).style.top = -(mouseY-230) + "px";
}

/*
$('.openModalBlog').click(function () {
    $('#modalBlog .name').html($(this).attr('name'));
    $('#modalBlog .tallerImgBig').attr('src',https + $(this).attr('img'));
    $('#modalBlog .tallerDescription').html($(this).attr('text'));
    $('#modalBlog').modal('open');
});
*/

/*
$('#listProject').change(function () {
    var value = this.value;

    if(value == 'todos'){
        $('#todos').css('visibility','initial');
        $('#stand').css('visibility','hidden');
        $('#escen').css('visibility','hidden');
        $('#islas').css('visibility','hidden');
        $('#retail').css('visibility','hidden');

        $('#todos').css('z-index','1');
        $('#stand').css('z-index','-1');
        $('#escen').css('z-index','-1');
        $('#islas').css('z-index','-1');
        $('#retail').css('z-index','-1');
    }
    if(value == 'stand'){
        $('#todos').css('visibility','hidden');
        $('#stand').css('visibility','initial');
        $('#escen').css('visibility','hidden');
        $('#islas').css('visibility','hidden');
        $('#retail').css('visibility','hidden');

        $('#todos').css('z-index','-1');
        $('#stand').css('z-index','1');
        $('#escen').css('z-index','-1');
        $('#islas').css('z-index','-1');
        $('#retail').css('z-index','-1');
    }
    if(value == 'escen'){
        $('#todos').css('visibility','hidden');
        $('#stand').css('visibility','hidden');
        $('#escen').css('visibility','initial');
        $('#islas').css('visibility','hidden');
        $('#retail').css('visibility','hidden');

        $('#todos').css('z-index','-1');
        $('#stand').css('z-index','-1');
        $('#escen').css('z-index','1');
        $('#islas').css('z-index','-1');
        $('#retail').css('z-index','-1');
    }
    if(value == 'islas'){
        $('#todos').css('visibility','hidden');
        $('#stand').css('visibility','hidden');
        $('#escen').css('visibility','hidden');
        $('#islas').css('visibility','initial');
        $('#retail').css('visibility','hidden');

        $('#todos').css('z-index','-1');
        $('#stand').css('z-index','-1');
        $('#escen').css('z-index','-1');
        $('#islas').css('z-index','1');
        $('#retail').css('z-index','-1');
    }
    if(value == 'retail'){
        $('#todos').css('visibility','hidden');
        $('#stand').css('visibility','hidden');
        $('#escen').css('visibility','hidden');
        $('#islas').css('visibility','hidden');
        $('#retail').css('visibility','initial');

        $('#todos').css('z-index','-1');
        $('#stand').css('z-index','-1');
        $('#escen').css('z-index','-1');
        $('#islas').css('z-index','-1');
        $('#retail').css('z-index','1');
    }
});s
*/
